import { z } from 'zod';
import { BaseEventSchema } from '../Base';

export enum PrescriptionsInteractionEventTypes {
  PrescriptionCameraClick = 'interaction.prescription.camera_click',
  PrescriptionUploadAttempt = 'interaction.prescription.upload_attempt',
  PrescriptionUploadSuccess = 'interaction.prescription.upload_success',
}

export const PrescriptionsInteractionEventTrackingSchemas = {
  [PrescriptionsInteractionEventTypes.PrescriptionUploadAttempt]:
    BaseEventSchema,
  [PrescriptionsInteractionEventTypes.PrescriptionUploadSuccess]:
    BaseEventSchema,
  [PrescriptionsInteractionEventTypes.PrescriptionCameraClick]: BaseEventSchema,
};
